import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ResponseVM } from '../../models/components/response.model';

@Component({
  selector: 'app-toggle-question',
  templateUrl: './toggle-question.component.html',
  styleUrl: './toggle-question.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleQuestionComponent),
      multi: true
    }
  ]
})
export class ToggleQuestionComponent implements OnInit, ControlValueAccessor {
  @Input() responses: ResponseVM[] = [];
  @Input() reduced: boolean = false;
  @Input() selectedResponse: ResponseVM | null = null;

  hoveredItem: ResponseVM | null = null;

  constructor() {}
  onTouched: () => void = () => {};

  writeValue(obj: any): void {
    if (obj !== undefined) {
      this.itemSelected =
        this.responses?.find((response: ResponseVM) => response.value === obj) ||
        ({} as ResponseVM);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  ngAfterViewInit() {
    let selectedResponse = this.responses?.find(r => r.isSelected && r.isSelected === true);
    if (selectedResponse) {
      this.onItemSelected(selectedResponse);
    }
  }

  private onChange: any = () => {};

  ngOnInit() {}

  itemSelected!: ResponseVM;

  onItemSelected(item: ResponseVM) {
    this.itemSelected = item;
    this.onChange(item['value']);
  }

  setClassActive(item: ResponseVM) {
    return {
      active: this.itemSelected === item,
      hovered: this.hoveredItem === item, // Élément actuellement survolé
      'not-hovered':
        this.hoveredItem !== null && this.hoveredItem !== item && this.itemSelected === item,
      'h-[5.5rem]': item.key.length > 30,
      'h-12': item.key.length <= 30
    };
  }

  mouseEnter(item: any) {
    this.hoveredItem = item;
  }

  mouseLeave(item: any) {
    this.hoveredItem = null;
  }
}
